import type { ServiceLayer } from '../types/gis';

export interface LayerConfig {
  slug: string;
  name: string;
  description: string;
}

export const LAYER_CONFIGS: Record<ServiceLayer, LayerConfig> = {
  'PINCODE': {
    slug: 'pincode',
    name: 'Post Offices',
    description: 'post offices and pincode boundaries'
  },
  'PDS': {
    slug: 'pds',
    name: 'Ration Shops',
    description: 'ration shops (PDS / fair price shops) with shop code, address, in-charge name, and phone number'
  },
  'TNEB': {
    slug: 'tneb',
    name: 'Electricity Board (TNEB)',
    description: 'TNEB section offices and electricity distribution areas'
  },
  'CONSTITUENCY': {
    slug: 'constituency',
    name: 'Constituencies',
    description: 'Assembly and Parliamentary constituency boundaries'
  },
  'POLICE': {
    slug: 'police',
    name: 'Police Stations',
    description: 'police stations and jurisdictional boundaries'
  },
  'HEALTH': {
    slug: 'health',
    name: 'Health Facilities',
    description: 'government hospitals, PHCs, and health sub-centres'
  },
  'LOCAL_BODIES_V2': {
    slug: 'local-bodies',
    name: 'Local Bodies',
    description: 'corporations, municipalities, and village panchayats'
  },
  'VETERINARY': {
    slug: 'veterinary',
    name: 'Veterinary Facilities',
    description: 'veterinary dispensaries, poly clinics, and hospitals'
  },
  'REGISTRATION': {
    slug: 'registration',
    name: 'Registration Offices',
    description: 'sub registrar offices and jurisdiction boundaries'
  },
  'LAND_PARCEL': {
    slug: 'land-parcel',
    name: 'Survey No. Finder',
    description: 'cadastral land parcel information and survey numbers'
  },
  'TEMPLES': {
    slug: 'temples',
    name: 'Temples (HRCE)',
    description: 'government-managed (HR&CE), heritage, and historical temples'
  },
  'RADIO': {
    slug: 'akashvani-fm',
    name: 'Akashvani FM',
    description: 'live local radio stations'
  },
  'FUEL': {
    slug: 'fuel',
    name: 'Fuel Outlets',
    description: 'fuel stations and petrol bunks'
  }
};
